import "./index.css";
import React, {Fragment} from "react";
import ReactDOM from "react-dom/client"

const pizzaData = [{
    name: "Focaccia",
    ingredients: "Bread with italian olive oil and rosemary",
    price: 6,
    photoName: "pizzas/focaccia.jpg",
    soldOut: false,
}, {
    name: "Pizza Margherita",
    ingredients: "Tomato and mozarella",
    price: 10,
    photoName: "pizzas/margherita.jpg",
    soldOut: false,
}, {
    name: "Pizza Spinaci",
    ingredients: "Tomato, mozarella, spinach, and ricotta cheese",
    price: 12,
    photoName: "pizzas/spinaci.jpg",
    soldOut: false,
}, {
    name: "Pizza Funghi",
    ingredients: "Tomato, mozarella, mushrooms, and onion",
    price: 12,
    photoName: "pizzas/funghi.jpg",
    soldOut: false,
}, {
    name: "Pizza Salamino",
    ingredients: "Tomato, mozarella, and pepperoni",
    price: 15,
    photoName: "pizzas/salamino.jpg",
    soldOut: true,
}, {
    name: "Pizza Prosciutto",
    ingredients: "Tomato, mozarella, ham, aragula, and burrata cheese",
    price: 18,
    photoName: "pizzas/prosciutto.jpg",
    soldOut: false,
},];

function App() {
    return <div className={"container"}>
        <Header/>
        <Menu/>
        <Footer/>
    </div>
}

function Header() {
    return <header className={"header"}>
        <h1>Fast React Pizza App</h1>
    </header>
}

function Menu() {
    const numPizzas = pizzaData.length;

    return <main className={"menu"}>
        <h2>Our Menu</h2>
        {
            numPizzas > 0 ? (
                    <Fragment>
                        <p>Authentic Italian cuisine. 6 creative dishes to choose from. All from our stone oven, all
                            organic, all delicious.</p>
                        <ul className={"pizzas"}>
                            {
                                pizzaData.map((pizza, key) => (
                                    <Pizza pizzaObj={pizza} key={key}/>
                                ))
                            }
                        </ul>
                    </Fragment>

                ) :
                (
                    <p>We're still working on our menu. Please come back later.</p>
                )
        }


        {/*        <div className={"pizzas"}>


            <Pizza
                name={"Pizza Spinaci"}
                ingredients={"Tomato, mozarella, spinach, and ricotta cheese"}
                imageUrl={"pizzas/salamino.jpg"}
                price={12}
                soldOut={false}
            />

        </div>*/}

    </main>
}


function Pizza({pizzaObj}) {

    return (
        <li className={`pizza ${pizzaObj.soldOut && "sold-out"}`}>
            <img src={pizzaObj.photoName} alt={pizzaObj.name}/>
            <div>
                <h3>{pizzaObj.name}</h3>
                <p>{pizzaObj.ingredients}</p>
                {pizzaObj.soldOut ? (
                    <span>SOLD OUT</span>
                ) : (
                    <span>{pizzaObj.price}</span>
                )}
                {/*<span>{pizzaObj.soldOut ? "SOLD OUT" : pizzaObj.price}</span>*/}
            </div>
        </li>
    )
}

function Footer() {
    const hour = new Date().getHours();
    const openHour = 12;
    const closeHour = 22;

    const isOpen = hour >= openHour && hour <= closeHour;
    // console.log(isOpen)

    // if (hour >= openHour && hour <= closeHour){
    //     alert("We're currently Open")
    // }else{
    //     alert("Sorry, we're closed");
    // }


    return <footer className={"footer"}>
        {
            isOpen ? (
                <Order closeHour={closeHour}/>

            ) : (
                <p>We're happy to welcome you between {openHour}:00 and {closeHour}:00.</p>
            )
        }
    </footer>
}


function Order({closeHour}) {
    return (
        <div className={"order"}>
            <p>
                We're open until {closeHour}:00. Come visit us or order online.
            </p>

            <button type={"button"} className={"btn"}>Order</button>
        </div>
    )
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode>
    <App/>
</React.StrictMode>)
